// extracted by mini-css-extract-plugin
export default {"root":"SupportContactFormTemplate_root__d9Abg","placeHolderShimmer":"SupportContactFormTemplate_placeHolderShimmer__UnGTz"};